import React from 'react';
import { regex, required, NumberInput } from 'react-admin';
import { InputAdornment } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = {
  inputFormat: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
  },
};

// accepts dollar amounts as 10 or 10.00, but not 10. or 10.0
const validateAmountDollarsCents = regex(
  /^\d{1,4}?(\.\d{2})?$/,
  'Must be a valid price, e.g. 10.99',
);

const PriceInput = withStyles(styles)(
  ({ resource, source, isRequired, classes, record, ...rest }) => {
    const validations = [validateAmountDollarsCents];

    if (isRequired) {
      validations.push(required());
    }

    let hideInput = false;
    // Don't show an Extra Oil Cost / Qt Input unless it's for an oil service
    if (record && record.service_offering) {
      hideInput =
        source === 'extra_oil_cost_per_qt_dollars' &&
        !record.service_offering.add_oil_cost;
    }

    if (hideInput) {
      return <span />;
    }

    return (
      <span className={classes.inputFormat}>
        <NumberInput
          {...rest}
          min={0.0}
          step={0.01}
          validate={validations}
          resource={resource}
          source={source}
          defaultValue={0.0}
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          }}
        />
      </span>
    );
  },
);
export default PriceInput;
